const path = 'whatsapp/conversations/'

const list = ({ opt = {} }) => axios.get(path, opt)
const show = ({ pk, opt = {} }) => axios.get(`${path}${pk}/`, opt)
const edit = ({ pk, form, opt = {} }) => axios.put(`${path}${pk}/`, form, opt)
const remove = ({ pk }) => axios.delete(`${path}${pk}/`)

// Historial y respuesta
const messages = ({ pk, opt = {} }) => axios.get(`${path}${pk}/messages/`, opt)
const reply = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/reply/`, form, opt)
const sendFile = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/send-file/`, form, {
    ...opt,
    headers: { 'Content-Type': 'multipart/form-data' }
  })

// Gestion de la conversacion
const assign = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/assign/`, form, opt)
const close = ({ pk, opt = {} }) => axios.post(`${path}${pk}/close/`, {}, opt)
const read = ({ pk, opt = {} }) => axios.post(`${path}${pk}/read/`, {}, opt)
// Quienes pueden atender la bandeja. No es la lista de usuarios de la
// empresa: ahi tambien estan sus clientes y proveedores.
const agents = ({ opt = {} }) => axios.get(`${path}agents/`, opt)
// Escribirle primero a un cliente que nunca escribio. Va con plantilla
// aprobada: fuera de la ventana de 24 horas no se admite texto libre.
const start = ({ form, opt = {} }) => axios.post(`${path}start/`, form, opt)

// Cliente
const candidates = ({ pk, opt = {} }) =>
  axios.get(`${path}${pk}/candidates/`, opt)
const createCustomer = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/create-customer/`, form, opt)
const linkCustomer = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/link-customer/`, form, opt)

// Contexto comercial
const context = ({ pk, opt = {} }) => axios.get(`${path}${pk}/context/`, opt)
const links = ({ pk, opt = {} }) => axios.get(`${path}${pk}/links/`, opt)
const link = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/links/`, form, opt)
const sendQuotation = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/send-quotation/`, form, opt)
const activity = ({ pk, opt = {} }) => axios.get(`${path}${pk}/activity/`, opt)

// Configuracion
const integration_path = 'whatsapp/integration/'
const integration = {
  list: ({ opt = {} }) => axios.get(integration_path, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${integration_path}${pk}/`, form, opt)
}

const usage = ({ opt = {} }) => axios.get('whatsapp/usage/', opt)

// Estado del complemento. Es el unico del modulo que responde con el
// complemento apagado: es justo lo que hay que leer para ofrecerlo.
const entitlement = ({ opt = {} }) => axios.get('whatsapp/entitlement/', opt)

const account_path = 'whatsapp/accounts/'
const account = {
  list: ({ opt = {} }) => axios.get(account_path, opt),
  create: ({ form, opt = {} }) => axios.post(account_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${account_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${account_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${account_path}${pk}/`),
  // Alta del canal con lo que devuelve la ventana de registro del proveedor
  onboard: ({ form, opt = {} }) =>
    axios.post(`${account_path}onboard/`, form, opt)
}

// Los archivos no se sirven por su ruta en disco: se piden autenticados y se
// muestran desde una url de objeto, que no se puede compartir.
const attachment_path = 'whatsapp/attachments/'
const attachment = {
  download: ({ pk, opt = {} }) =>
    axios.get(`${attachment_path}${pk}/download/`, {
      ...opt,
      responseType: 'blob'
    })
}

const queue_path = 'whatsapp/queues/'
const queue = {
  list: ({ opt = {} }) => axios.get(queue_path, opt),
  create: ({ form, opt = {} }) => axios.post(queue_path, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${queue_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${queue_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${queue_path}${pk}/`)
}

const hours_path = 'whatsapp/business-hours/'
const businessHours = {
  list: ({ opt = {} }) => axios.get(hours_path, opt),
  create: ({ form, opt = {} }) => axios.post(hours_path, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${hours_path}${pk}/`, form, opt),
  remove: ({ pk }) => axios.delete(`${hours_path}${pk}/`)
}

const template_path = 'whatsapp/templates/'
const template = {
  list: ({ opt = {} }) => axios.get(template_path, opt),
  show: ({ pk, opt = {} }) => axios.get(`${template_path}${pk}/`, opt)
}

const preference_path = 'whatsapp/preferences/'
const preference = {
  list: ({ opt = {} }) => axios.get(preference_path, opt),
  create: ({ form, opt = {} }) => axios.post(preference_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${preference_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${preference_path}${pk}/`, opt)
}

export default {
  list,
  show,
  edit,
  remove,
  messages,
  reply,
  sendFile,
  assign,
  close,
  read,
  agents,
  start,
  candidates,
  createCustomer,
  linkCustomer,
  context,
  links,
  link,
  sendQuotation,
  activity,
  integration,
  usage,
  entitlement,
  account,
  attachment,
  queue,
  businessHours,
  template,
  preference
}
